module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-top.73cd7afc.svg";